import './game-genre.css'

export const GameGenre = ({ genre }) => {
  return(
      <div className="game-genre">{genre}</div>
    
  )
}